import { render, staticRenderFns } from "./CampusGuidesKicker.vue?vue&type=template&id=1a13c6f8"
import script from "./CampusGuidesKicker.vue?vue&type=script&lang=js"
export * from "./CampusGuidesKicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports